(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mezetto-newsletter"]) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.mzReady) return;
    root.dataset.mzReady = 'true';
    const focus = root.querySelector('[data-mz-focus]');
    focus.hidden = false;
    focus.addEventListener('click', () => {
      const active = focus.getAttribute('aria-pressed') !== 'true';
      root.dataset.focused = String(active);
      focus.setAttribute('aria-pressed', String(active));
    });
    const share = root.querySelector('[data-mz-share]');
    if (navigator.share || navigator.clipboard) {
      share.hidden = false;
      share.addEventListener('click', async () => {
        try {
          if (navigator.share) await navigator.share({title: root.querySelector('h1').textContent, url: share.dataset.url});
          else { await navigator.clipboard.writeText(share.dataset.url); const status = root.querySelector('[data-mz-status]'); status.textContent = status.dataset.copied; }
        } catch (_) {}
      });
    }
    const progress = root.querySelector('progress');
    progress.hidden = false;
    let ticking = false;
    const update = () => {
      const rect = root.getBoundingClientRect();
      progress.value = Math.max(0, Math.min(100, -rect.top / Math.max(1, rect.height - innerHeight) * 100));
      ticking = false;
    };
    const scroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    addEventListener('scroll', scroll, {passive:true});
    addEventListener('resize', scroll, {passive:true});
    update();
    if (!('IntersectionObserver' in window)) return;
    const links = [...root.querySelectorAll('a[data-product-handle]')];
    const cache = new Map();
    const queued = new Set();
    const queue = [];
    let running = 0;
    const isOpen = (a) => !a.closest('details:not([open])');
    const remove = (a) => { if (!a.isConnected) return; const span = document.createElement('span'); span.className = a.className; if (a.id) span.id = a.id; span.append(...a.childNodes); a.replaceWith(span); };
    const apply = (path, status) => { if (status === 404 || status === 410) links.filter(a => a.isConnected && new URL(a.href).pathname === path).forEach(remove); };
    const pump = () => {
      while (running < 3 && queue.length) {
        const {a, path} = queue.shift();
        queued.delete(path);
        if (!a.isConnected || !isOpen(a)) continue;
        if (cache.has(path)) { apply(path, cache.get(path)); continue; }
        cache.set(path, 0);
        running += 1;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 6000);
        fetch(path, {method:'HEAD', credentials:'same-origin', redirect:'follow', signal:controller.signal})
          .then(response => { const finalUrl = new URL(response.url, location.href); const status = finalUrl.origin === location.origin && finalUrl.pathname === path ? response.status : 0; cache.set(path,status);apply(path,status);})
          .catch(() => {cache.set(path,0);})
          .finally(() => {clearTimeout(timeout);running -= 1;pump();});
      }
    };
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const a = entry.target;
        if (!isOpen(a)) continue;
        let url;
        try {url = new URL(a.href);} catch (_) {continue;}
        if (url.origin !== location.origin || !url.pathname.startsWith('/products/')) continue;
        observer.unobserve(a);
        if (cache.has(url.pathname)) {apply(url.pathname,cache.get(url.pathname));continue;}
        if (!queued.has(url.pathname)) {queued.add(url.pathname);queue.push({a,path:url.pathname});}
      }
      pump();
    }, {rootMargin:'200px 0px'});
    links.filter(isOpen).forEach(a => observer.observe(a));
    root.querySelectorAll('details').forEach(details => details.addEventListener('toggle', () => {
      details.querySelectorAll('a[data-product-handle]').forEach(a => {observer.unobserve(a);if (isOpen(a)) observer.observe(a);});
    }));
  };
  document.querySelectorAll('[data-mz-newsletter]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mz-newsletter]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
